import * as React from "react";
const SvgCaretUp = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12 4 6.75 9.19 1.5 14.378v1.803c0 .992.004 1.808.008 1.812.004.004 4.727.008 10.496.006l10.49-.004.004-1.808.002-1.809-5.25-5.19z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgCaretUp;
